import { type FC } from "react";
import { Alert, AlertTitle, Box, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import capitalize from "lodash/capitalize";

import { ReactComponent as PacksizeIcon } from "@/assets/images/branding/packsize-icon.svg";

interface InternalPreviewMessageProps {
	readonly tier: string;
}

const InternalPreviewMessage: FC<InternalPreviewMessageProps> = ({ tier }) => {
	return (
		<Alert severity="info" icon={false} data-testid="internal-preview-message" sx={{ mb: 3 }}>
			<Grid container alignItems="center" gap={2}>
				<PacksizeIcon />
				<Box>
					<AlertTitle sx={{ fontWeight: "bold", mb: 0.5 }}>
						<FormattedMessage id="Internal Preview" defaultMessage="Internal Preview" />
					</AlertTitle>
					<Typography variant="inherit">
						<FormattedMessage
							id="This customer does not have access to this feature. A {tier} Reporting license is required."
							defaultMessage="This customer does not have access to this feature. A {tier} Reporting license is required."
							values={{ tier: capitalize(tier) }}
						/>
					</Typography>
				</Box>
			</Grid>
		</Alert>
	);
};

export default InternalPreviewMessage;
